<template>
    <div class="all" :style="'background-color:'+jobInfo.jobExInfo.bgColor">
        <van-nav-bar
                :title="jobInfo.name"
                left-text="返回"
                left-arrow
                @click-left="$goBack()"
        />

        <div style="width: 95%;margin: auto">
            （实时数据查询）
            <van-field
                    v-model="titleTimeStart"
                    placeholder="选择开始时间" readonly="readonly"
                    @click="dateShowStart = true"
            />

            <div class="table-box" v-if="runtimeData.page&&runtimeData.page.length>0">
                <table width="100%">
                    <tr v-for="(row,index) in runtimeData.page" :key="row.id">
                        <td style="text-align:left;word-break:break-all;">
                            <div>
                                <van-cell  :value="row.orderid"/>
                                <van-cell title="订单时间" :value="row.paytime|parseTime('{y}-{m}-{d} {h}:{i}:{s}')"/>

                                <van-cell title="标题" :value="row.smstitle"/>
                                <van-cell title="订单状态" :value="mtPayStatusMap[row.status]"/>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
            <van-popup v-model="dateShowStart" position="bottom">
                <van-datetime-picker v-model="currentDateStart" type="date" @cancel="handleCancel"
                                     @confirm="handleStartDateConfirm5"/>
            </van-popup>
            <van-popup v-model="dateShow" position="bottom">
                <van-datetime-picker v-model="currentDate" type="date" @cancel="handleCancel"
                                     @confirm="handleEndDateConfirm5"/>
            </van-popup>
        </div>

    </div>
</template>

<script>
    import weixin from '@/assets/images/weixin1.png'
    import wxfriend from '@/assets/images/wxfriend.png'
    import qq from '@/assets/images/qq1.png'
    import QQZone from '@/assets/images/QQZone1.png'
    import lqdefault from '@/assets/images/lqdefault.jpg'
    import QRCode from 'qrcodejs2'
    import vueQr from 'vue-qr'
    import mainAPI from '@/api/main'
    import countAPI from '@/api/count'
    import {ImagePreview} from "vant";

    export default {
        components: {
            vueQr
        },
        data() {
            return {
                share: {
                    weixin: weixin,
                    wxfriend: wxfriend,
                    qq: qq,
                    QQZone: QQZone,
                    show: false,
                    overlay: ''
                },
                lqdefault: lqdefault,
                jobInfo: {
                    id: null,
                    name: null,
                    linkTpl: '',
                    linkMode: '',
                    jobQrCode: null,
                    jobLink: '',
                    traderId: '',
                    jobExInfo: {
                        bannerUrl: '',
                        logoUrl: '',
                        ruleUrl: '',
                        courseUrl: '',
                        bgColor: '',
                        videoUrl: ''
                    },
                    linkAtrr1: '',
                    linkAtrr2: ''
                },
                sid:this.$route.query.sid,
                actId:this.$route.query.actId,
                query: {
                    id: this.$route.query.id,
                    biz: this.$route.query.biz
                },
                apply: {
                    show: false,
                    account: ''
                },
                jdAreaShow: false,
                jdAreaList: {
                    province_list: {}
                },
                stbaGuide: {
                    show: false,
                    url: ''
                },
                pageStyle: '',
                dateShow: false,
                currentDate: new Date(),
                titleTime: "",
                dateShowStart: false,
                titleTimeStart: "",
                currentDateStart: new Date(),
                runtimeData: {},
                dialogVisible: false,
                dialogData: {},
                declareVisible: false,
                declareForm: {
                    jobId: null,
                    phone: '',
                    orderId: '',
                    proofImg1: '',
                    proofImg2: '',
                },
                camera: 'http://jho2o2.oss-cn-beijing.aliyuncs.com/test/2NWMQ23p.png',
                exampleImg1: 'http://jho2o2.oss-cn-beijing.aliyuncs.com/test/2NWMOZd3.png',
                exampleImg2: '',
                shareDialog: false,
                shareText: '',
                shareDialogVisible: false,
                shareImgSrc: '',
                painting: {
                    width: '565px',
                    height: '800px',
                    background: '#f4f5f7',
                    views: []
                },
                signVisible: false,
                signForm: {
                    companyName: null,
                    unifiedCreditCode: null,
                    phone: null,
                },
                jdPayStatusMap: {"0": "待付款", "1": "已付款(已用券)", "2": "已付款发货失败", "3": "已还款", "4": "已付款(未用券)"},
                mtPayStatusMap: { "1": "已付款", "8": "已完成", "9": "已退款或风控"},

                fugouDialogVisible: false,

                playerOptions : {
                    playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
                    autoplay: false, //如果true,浏览器准备好时开始回放。
                    muted: false, // 默认情况下将会消除任何音频。
                    loop: false, // 导致视频一结束就重新开始。
                    preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                    language: 'zh-CN',
                    aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                    fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                    sources: [{
                        src: '',  // 路径
                        type: 'video/mp4'  // 类型
                    }],
                    poster: "", //你的封面地址
                    // width: document.documentElement.clientWidth,
                    notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                    controlBar: {
                        timeDivider: true,
                        durationDisplay: true,
                        remainingTimeDisplay: false,
                        fullscreenToggle: true  //全屏按钮
                    }
                }
            }
        },
        created() {

        },
        methods: {
            choosePageStyle() {
                if (this.jobInfo.bizId === 118) {
                    // 隐藏副标题，拉新规则 改为 商家二维码
                    this.pageStyle = 1
                }
            },
            signUp() {
                if (this.jobInfo.id) {
                    // if (55 == this.jobInfo.id) {
                    //     this.signVisible = true;
                    //     return;
                    // }

                    this.$toast.loading({forbidClick: true})
                    if ("LINK_MODE_BY_STOCK_ACCACH_AREA" === this.jobInfo.linkTpl && !this.jobInfo.linkAtrr1) { // 京东任务且未选择省份
                        mainAPI.getJdProvince(this.jobInfo.bizId).then((result) => {
                            this.jdAreaList.province_list = result.data
                            this.jdAreaShow = true
                            this.$toast.clear()
                        })
                        return
                    }
                    mainAPI.signUp(this.jobInfo.id, this.apply.account, this.jobInfo.linkAtrr1, this.jobInfo.linkAtrr2).then((result) => {
                        if (result.mng === 'stlx_beian') {
                            // 手淘拉新未备案弹出备案引导
                            this.stbaGuide.url = result.data
                            this.stbaGuide.show = true
                            return
                        }
                        this.$toast.success('领取成功')
                        this.$toast.clear()
                        this.taskInfo()
                    })
                }
            },
            applyDialog() {
                this.apply.show = true
            },
            applyConfirm() {
                if (!this.apply.account) {
                    this.$toast('请填写申请账号')
                    return
                }
                // if (!this.$myUtil.mobile(this.apply.account)) {
                //     this.$toast('请填写正确的手机号账号')
                //     return
                // }
                this.signUp()
            },
            applyCancel() {
            },
            qrCallback(url, id) {
            },
            savePhoto() {
            },
            base64ImgDataToBlob(base64ImgData) {
                var arr = base64ImgData.split(','),
                    mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]),
                    n = bstr.length,
                    u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new Blob([u8arr], {type: mime});
            },
            getObjectURL(file) {
                var url = null;
                if (window.createObjectURL !== undefined) { // basic
                    url = window.createObjectURL(file);
                } else if (window.URL !== undefined) { // mozilla(firefox)
                    url = window.URL.createObjectURL(file);
                } else if (window.webkitURL !== undefined) { // webkit or chrome
                    url = window.webkitURL.createObjectURL(file);
                }
                return url;
            },
            jdAreaCancel() {
                this.jdAreaShow = false
            },
            jdAreaConfirm(e) {
                this.jobInfo.linkAtrr1 = e[0].name
                this.jdAreaShow = false
                this.signUp()
                this.jobInfo.linkAtrr1 = ''
            },
            handleCancel() {
                this.dateShow = false;
                this.dateShowStart = false;
            },
            //开始时间
            handleStartDateConfirm() {
                this.dateShowStart = false;
                this.titleTimeStart = this.timeFormat(this.currentDateStart);
                this.queryJdcpaDetail();
            },
            //结束时间
            handleEndDateConfirm() {
                this.dateShow = false;
                this.titleTime = this.timeFormat(this.currentDate);
                this.queryJdcpaDetail();
            },
            handleEndDateConfirm2() {
                this.dateShow = false;
                this.titleTime = this.timeFormat(this.currentDate);
                this.querySaasDetail();
            },
            handleStartDateConfirm3() {
                this.dateShowStart = false;
                this.titleTimeStart = this.timeFormat(this.currentDateStart);
                this.querySuNingDetail();
            },
            handleEndDateConfirm3() {
                this.dateShow = false;
                this.titleTime = this.timeFormat(this.currentDate);
                this.querySuNingDetail();
            },
            handleStartDateConfirm4() {
                this.dateShowStart = false;
                this.titleTimeStart = this.timeFormat(this.currentDateStart);
                this.queryJdpayOrderDetail();
            },
            handleEndDateConfirm4() {
                this.dateShow = false;
                this.titleTime = this.timeFormat(this.currentDate);
                this.queryJdpayOrderDetail();
            },
            handleStartDateConfirm5() {
                this.dateShowStart = false;
                this.titleTimeStart = this.timeFormat5(this.currentDateStart);
                this.queryMeituanDetail();
            },
            handleEndDateConfirm5() {
                this.dateShow = false;
                this.titleTime = this.timeFormat5(this.currentDate);
                this.queryMeituanDetail();
            },
            timeFormat(datetime) { // 时间格式化 2019-09-08
                var year = datetime.getFullYear();
                var month = (datetime.getMonth() + 1) < 10 ? "0" + (datetime.getMonth() + 1) : (datetime.getMonth() + 1);
                var date = datetime.getDate() < 10 ? "0" + datetime.getDate() : datetime.getDate();
                var hour = datetime.getHours() < 10 ? "0" + datetime.getHours() : datetime.getHours();
                var minute = datetime.getMinutes() < 10 ? "0" + datetime.getMinutes() : datetime.getMinutes();
                var second = datetime.getSeconds() < 10 ? "0" + datetime.getSeconds() : datetime.getSeconds();
                return year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
            }
            ,
            timeFormat5(datetime) { // 时间格式化 2019-09-08
                var year = datetime.getFullYear();
                var month = (datetime.getMonth() + 1) < 10 ? "0" + (datetime.getMonth() + 1) : (datetime.getMonth() + 1);
                var date = datetime.getDate() < 10 ? "0" + datetime.getDate() : datetime.getDate();
                var hour = datetime.getHours() < 10 ? "0" + datetime.getHours() : datetime.getHours();
                var minute = datetime.getMinutes() < 10 ? "0" + datetime.getMinutes() : datetime.getMinutes();
                var second = datetime.getSeconds() < 10 ? "0" + datetime.getSeconds() : datetime.getSeconds();
                return year + "-" + month + "-" + date + "" ;
            }
            ,
            queryJdcpaDetail() {
                //if(!isNaN(this.month4selected)){
                //  this.queryLog.startSettleDate=this.$myUtil.startDateDef(this.month4selected*30)
                //}

                if (this.titleTime && this.titleTimeStart) {
                    this.$toast.loading({forbidClick: true});

                    let queryObj = {};
                    queryObj.ext1 = this.titleTime;
                    // queryObj.ext2 = this.jobInfo.linkAtrr1;
                    queryObj.ext2 = this.jobInfo.jobLinkUpPid;
                    queryObj.ext3 = this.titleTimeStart;
                    if (this.jobInfo.id == 6 || this.jobInfo.id == 67) {
                        queryObj.ext4 = 2;
                    }

                    countAPI.jdCpaDetail(queryObj).then((result) => {
                        this.runtimeData = result.data;
                        this.$toast.clear()
                    })
                }
            },

            querySaasDetail() {
                this.$toast.loading({forbidClick: true});
                let queryObj = {};

                queryObj.ext1 = this.titleTime;
                queryObj.ext2 = this.jobInfo.linkAtrr1;
                queryObj.jobId = this.jobInfo.id;

                countAPI.saasDetail(queryObj).then((result) => {
                    this.runtimeData = result.data;
                    this.$toast.clear()
                })
            },

            querySuNingDetail() {
                let queryObj = {};
                if (this.titleTime && this.titleTimeStart) {
                    this.$toast.loading({forbidClick: true});
                    queryObj.ext1 = this.titleTimeStart;
                    queryObj.ext2 = this.titleTime;
                    queryObj.ext3 = this.jobInfo.jobLinkUpPid;

                    countAPI.suningDetail(queryObj).then((result) => {
                        this.runtimeData = result.data;
                        this.$toast.clear()
                    })
                }
            },
            queryJdpayOrderDetail() {
                let queryObj = {};
                if (this.titleTime && this.titleTimeStart) {
                    this.$toast.loading({forbidClick: true});
                    queryObj.ext1 = this.titleTimeStart;
                    queryObj.ext2 = this.titleTime;
                    queryObj.ext3 = this.jobInfo.jobLinkUpPid;

                    countAPI.jdpayOrderDetail(queryObj).then((result) => {
                        this.runtimeData = result.data;
                        this.$toast.clear()
                    })
                }
            },

            queryMeituanDetail() {


                if (this.titleTimeStart ) {
                    this.$toast.loading({forbidClick: true});

                    let queryObj = {};
                    //queryObj.ext1 = this.titleTime;
                    // queryObj.ext2 = this.jobInfo.linkAtrr1;
                    queryObj.ext2 = this.sid;
                    //queryObj.ext2 = 'mb1361';
                    queryObj.ext3 = this.titleTimeStart;
                    queryObj.actId=this.actId;



                    countAPI.meituanDetail(queryObj).then((result) => {
                        this.runtimeData = result.data;
                        this.$toast.clear()
                    })
                }
            },
            openDialog(row) {
                this.dialogVisible = true;
                this.dialogData = row;
            },

            stbaAction(action, done) {
                if (action === 'confirm') {
                    const _this = this
                    this.$copyText(this.stbaGuide.url).then(function () {
                        _this.$toast({
                            type: 'success',
                            message: '复制成功'
                        })
                    }, function () {
                        _this.$toast({
                            type: 'warning',
                            message: '复制失败'
                        })
                    })
                    done(false)
                } else if (action === 'cancel') {
                    this.signUp()
                    done()
                } else {
                    done()
                }
            },

            onRead(type) { // 上传图片到图片服务器
                let file = document.getElementById('logimg' + type).files[0];

                let self = this;
                let reader = new FileReader();
                reader.onload = e => {
                    let result = e.target.result;
                    let formData = new FormData();
                    formData.append("dirName", "任务报单上传目录");

                    if (result.length / 1024 > 500) {
                        let img = new Image();
                        img.src = result;
                        img.onload = function () {
                            self.$toast("开始压缩图片...");
                            //0.6为压缩的程度，数值越小，压缩的文件越小，图片也会越模糊
                            let src = self.$myUtil.compressImg(img, 0.6);
                            formData.append("file", self.$myUtil.base64ImgDataToFile(src, file.name));
                            self.uploadImg(formData, type);
                        }
                    } else {
                        formData.append("file", file);
                        self.uploadImg(formData, type);
                    }
                };
                // 读取图像
                reader.readAsDataURL(file);
            },
            //上传图片
            uploadImg(formData, type) {
                this.$toast("开始上传图片...");
                this.$http.post('/sys/ossFileMapping/upload', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(res => {
                    if (1 === type) {
                        this.declareForm.proofImg1 = res.data; //这里上传到指定的图片服务器，成功后会返回图片的url
                    } else if (2 === type) {
                        this.declareForm.proofImg2 = res.data;
                    }
                    this.$toast("图片上传成功");
                }).catch(() => {
                    this.$toast("图片上传失败");
                })
            },
            previewExampleImg1() {
                ImagePreview([
                    this.exampleImg1,
                ]);
            },
            previewExampleImg2() {
                ImagePreview([
                    this.exampleImg2,
                ]);
            },
            declareOrder() {
                if (!this.declareForm.orderId) {
                    this.$toast("请先填写订单号");
                    return;
                }
                // if (!this.declareForm.phone) {
                //     this.$toast("请先填写手机号");
                //     return;
                // }
                // if (!this.declareForm.proofImg1) {
                //     this.$toast("请先上传凭证");
                //     return;
                // }
                // if (!this.declareForm.proofImg2) {
                //     this.$toast("请先上传凭证");
                //     return;
                // }
                this.declareForm.jobId = this.jobInfo.id;
                mainAPI.jobOrderDeclare(this.declareForm).then(() => {
                    this.closeDeclareDialog();
                    this.$toast("报单成功");
                }).catch(() => {
                });
            },
            closeDeclareDialog() {
                this.declareForm.phone = '';
                this.declareForm.orderId = '';
                this.declareForm.proofImg1 = '';
                this.declareVisible = false;
            },
            openShareDialog() {
                this.shareDialog = true;
            },
            onError() {
                this.$toast.fail('复制失败')
            },
            onCopy() {
                this.$toast.success('分享文案已经复制到剪切板')
            },
            success(src) {
                this.shareImgSrc = src;
            },
            fail(err) {
                console.log('fail', err)
            },
            addPoster() {
                this.painting.views.push(
                    {
                        type: 'image',
                        url: this.jobInfo.jobExInfo.posterUrl,
                        css: {}
                    }
                );
                this.painting.views.push(
                    {
                        type: 'rect',
                        css: {
                            top: '610px',
                            left: '400px',
                            color: '#fff',
                            width: '110px',
                            height: '110px'
                        }
                    }
                );

                if(this.jobInfo.jobQrCode.indexOf("http")>=0){
                    this.painting.views.push({
                        type: 'qrcode',
                        content: this.jobInfo.jobQrCode,
                        css: {
                            top: '612px',
                            left: '402px',
                            color: '#000',
                            width: '106px',
                            height: '106px'
                        }
                    });
                }
                if(this.jobInfo.jobQrCode.indexOf("data:image")>=0){
                    this.painting.views.push({
                         type: 'image',
                        url: this.jobInfo.jobQrCode,
                        css: {
                            top: '612px',
                            left: '402px',
                            color: '#000',
                            width: '106px',
                            height: '106px'
                        }
                    });
                }

            },
            signContract() {
                if (!this.signForm.companyName || !this.signForm.unifiedCreditCode || !this.signForm.phone) {
                    this.$toast("请先填写信息");
                    return;
                }
                this.$toast("协议签署中...");
                mainAPI.signContract(this.signForm.companyName, this.signForm.unifiedCreditCode, this.signForm.phone).then(() => {
                    window.location.href = "http://mengbao123.mikecrm.com/JNXNcnk";
                }).catch(() => {
                });
            }
        }
    }
</script>

<style lang="scss" scoped>

    .video-js .vjs-big-play-button {
        left: 50% !important;
        top: 50% !important;
        margin-left: -1.5em;
        margin-top: -1em;
    }
    .banner {
        width: 100%;
        height: auto;

    img {
        width: 100%;
        height: 100%;
    }

    background-size: 100% auto;
    overflow: hidden;
    }

    .middlek {
        background-color: #fff;
        margin: 1rem 2%;
        border-radius: 1rem;
        padding: 1rem;
    }

    .middle {
        background-color: #fff;
        margin: 1rem 8%;
        border-radius: 1rem;
        padding: 1rem;

        .title {
            font-size: 1.6rem;
            font-weight: bold;
            text-align: center;
        }

        .sub_title {
            font-size: 1rem;
            text-align: center;
            padding: 1rem 0 0 0;
            color: #888;
        }

        .qrCode {
            margin: 1rem auto 0 auto;
            width: 15.42rem;
            height: 15.42rem;
            background: white;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .bottom {
            margin: 1rem 8% 0 8%;

            a {
                color: blue;
                text-decoration: underline;
            }
        }
        .showJdOrder {
            text-align: center;
            border-top: 1px solid #f2f2f2;
            border-left: 1px solid #f2f2f2;
            border-right: 1px solid #f2f2f2;
            color: #7d7e80;
            .rowOrder {
                height: 19rem;
                .head {
                    color: #000;
                }
            }
            .table-box {
                height: 19rem;
                width: 100%;
                overflow-x: scroll;
                white-space: nowrap;
                -webkit-overflow-scrolling: touch;
                table tr td {
                    text-align: center;
                    line-height: 1.6rem;
                }
            }
        }

        // .bottom{
        //   margin: 1rem 10% 0 10%;
        //   display: flex;
        //   justify-content:space-around;
        //   .left {
        //     display: flex;
        //     justify-content:flex-start;
        //   }
        //   .right {
        //     display: flex;
        //     justify-content:flex-end;
        //   }
        // }

        .applyExplain {
            margin: 1rem 5% 1rem 15%;
            font-size: 1rem;
            color: #888;
            line-height: 2rem;
        }

        .applyBut {
            background-color: #f2f2f2;
            margin: 2rem 10%;
            height: 3rem;
            border-radius: 2rem;
            text-align: center;
            line-height: 3rem;
            color: blue;
        }

    }

    .button {
        background-color: #fff;
        margin: 2rem 10%;
        height: 3rem;
        border-radius: 2rem;
        text-align: center;
        line-height: 3rem;
    }

    .share {
        .van-popup {
            background-color: #f2f2f2;
            text-align: center;
            font-size: 1.2rem;

        }

        .van-row {
            margin: 2rem 3rem;

            .van-col {
                font-size: 1rem;
            }
        }

        img {
            height: 3rem;
            width: 3rem;
        }
    }

    .uploader_box {
        width: 7rem;
        height: 11rem;
        overflow: hidden;
        position: relative;

        img {
            width: 100%;
            height: 100%;
        }
    }

    #logimg1, #logimg2 {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
    }

    #shareBtn {
        color: blue;
        background-color: transparent;
        border: 0px none; //去边框
        font-size: 15px;
        text-decoration: underline; //加下划线
    }

</style>
